import React, {useEffect} from 'react'

const GoogleTagManagerScript = () => {
  useEffect(() => {
    if (!process.env.REACT_APP_GOOGLE_TAG_MANAGER_SCRIPT) return
    const script = document.createElement('script')
    // @ts-ignore
    script.src = process.env.REACT_APP_GOOGLE_TAG_MANAGER_SCRIPT
    script.async = true
    document.head.appendChild(script)
  }, [])

  useEffect(() => {
    if (!process.env.REACT_APP_GOOGLE_TAG_MANAGER_SCRIPT) return
    const script = document.createElement('script')
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-JHY4RF5Q9W'
    script.async = true
    document.head.appendChild(script)

    const script2 = document.createElement('script')
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-JHY4RF5Q9W');
    `
    document.head.appendChild(script2)

    const script3 = document.createElement('script')
    script3.innerHTML = `
  (function (f, b, e, v, n, t, s) {
  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []
  t = b.createElement(e)
  t.async = !0
  t.src = v
  s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  fbq('init', '1266373554490172')
  fbq('track', 'PageView')
  `
    document.head.appendChild(script3)

    const script4 = document.createElement('script')
    script4.innerHTML = `
    (function (w, d, t) {
    w.TiktokAnalyticsObject = t
    var ttq = (w[t] = w[t] || [])
    ;(ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
    'holdConsent',
    'revokeConsent',
    'grantConsent',
    ]),
    (ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
      }
    })
    for (var i = 0; i < ttq.methods.length; i++)
    ttq.setAndDefer(ttq, ttq.methods[i])
    ;(ttq.instance = function (t) {
    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
      ttq.setAndDefer(e, ttq.methods[n])
    return e
    }),
    (ttq.load = function (e, n) {
      var r = 'https://analytics.tiktok.com/i18n/pixel/events.js',
        o = n && n.partner
      ;(ttq._i = ttq._i || {}),
        (ttq._i[e] = []),
        (ttq._i[e]._u = r),
        (ttq._t = ttq._t || {}),
        (ttq._t[e] = +new Date()),
        (ttq._o = ttq._o || {}),
        (ttq._o[e] = n || {})
      n = document.createElement('script')
      ;(n.type = 'text/javascript'),
        (n.async = !0),
        (n.src = r + '?sdkid=' + e + '&lib=' + t)
      e = document.getElementsByTagName('script')[0]
      e.parentNode.insertBefore(n, e)
    })

    ttq.load('CSK88MRC77UAC5GFINT0')
    ttq.page()
    })(window, document, 'ttq')
  `
    document.head.appendChild(script4)
  }, [])

  if (!process.env.REACT_APP_GOOGLE_TAG_MANAGER_SCRIPT) return null

  return (
    <>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PG3LV6M7"
          height="0"
          width="0"
          style="display:none;visibility:hidden"></iframe>
      </noscript>
      <noscript>
        <img
          height="1"
          width="1"
          style="display:none"
          src="https://www.facebook.com/tr?id=1266373554490172&ev=PageView&noscript=1"
        />
      </noscript>
    </>
  )
}

export default GoogleTagManagerScript
